export interface MeldungArt {
  id     : number;
  letter : string;
}

export enum MeldungArtId {
  ALPHA = 10,
  BETA  = 20,
  GAMMA = 30
}
